import React, { useState, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { Input } from "mdb-ui-kit"; // module
import "mdb-ui-kit/css/mdb.min.css";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import "../UserBranchRoles/Styles/UserBranchRoleForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";
import { useTheme } from '@mui/material/styles';
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from "@mui/material";
import { useGlobalContext } from '../../../../../context'
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';


const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function AddStageTransactionPermissionForm(props) {
  // console.log("UserBranchRoleForm props", props);
  const theme = useTheme();
  const [userBranchRolesSelected, setUserBranchRolesSelected] = useState([]);
  const [branch, setBranch] = useState({});
  const [userBranchList, setUserBranchList] = useState(props?.userBranchList)
  const [loading, setLoading] = useState(false);
  const {  transactionTypes,permissions,sections,roleStageTransactionTypePermission, fetchData } = useGlobalContext()
  const [TransactionDataList,setTransactionDataList]=useState([]);
  const [permissionsList, setPermissionsList] = React.useState([])
  const [emptyArr,setEmptyArr]=useState([])
  const [listOfDataForStore,setListOfDataForStore]=useState([])
  const [collapseShowing,setCollapseShowing]=useState([]);
  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const [roles, setRoles] = useState([]);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;
  

  useEffect(() => {
    setUserBranchList(props?.userBranchList)
  }, [props.userBranchList]);


  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };

  useEffect(()=>{
    fetchData('TRANSACTIONTYPES','transaction_types_list',{})
    fetchData('PERMISSIONS','permissions_list',{})
    fetchData('SECTIONS','sections_list',{})
  },[])
  useEffect(()=>{
    if(transactionTypes&&transactionTypes.length>0)
       getDataFromDataBase(transactionTypes)
  },[transactionTypes])

  const getTransactionTypeName=(id)=>{
      if(transactionTypes.length>0){
        let name='';
        transactionTypes.map((data)=>{
          if(data?.stage_transaction_type&&data?.stage_transaction_type.length>0){
            data?.stage_transaction_type?.map((stage)=>{
              if(stage?.id==id){
                name=data?.name;
              }
            })
          
          }
        })
        return name;
      }
  }
  const getStageName=(id)=>{ 
    if(transactionTypes.length>0){
      let name=''
      transactionTypes.map((data)=>{
        if(data?.stage_transaction_type&&data?.stage_transaction_type?.length>0){
          data?.stage_transaction_type?.map((stage)=>{
            if(stage?.id==id){
              name=stage?.stage?.name;
            }
        })
      }
      })
      return name;
    }
  }

  const getPermissionName=(id)=>{
    if(permissions.length>0){
      let name =null;
      permissions.map((data)=>{
        if(data?.id==id){
            name=data.name;
        }
      })
      return name;
    }
  }

  useEffect(()=>{
      // console.log(listOfDataForStore);
      let arr=[];
      if(listOfDataForStore && listOfDataForStore.length>0)
      {
        
        let counter=props?.rows?.length;
        listOfDataForStore.map((data)=>{
          let role_id = props?.object?.id
          let role_name = props?.object?.name
          let transaction_name = getTransactionTypeName(data?.stage_transaction_type_id)
          let stage_transaction_type_id=data?.stage_transaction_type_id
          let stage_name=getStageName(data?.stage_transaction_type_id)

          data?.sections_dataset?.map((data1)=>{
            if(data1?.permission_list&& data1?.permission_list?.length>0){
              data1?.permission_list?.map((data2)=>{
                if(getCheckIfIsRepeated(data2,stage_name,transaction_name,data1?.section_id)){
                    counter++;
                    arr.push({
                      id:counter,
                      role_id:role_id,
                      role_name:role_name,
                      transaction_name:transaction_name,
                      stage_transaction_type_id:stage_transaction_type_id,
                      stage_name:stage_name,
                      permission_id:data2,
                      permission_name:getPermissionName(data2),
                      section_name:data1?.section_name,
                      section_id:data1?.section_id
                    })
                }
              })
                
            }
          })
        })

        //check if element added befor to the list
        props?.setRows(arr)
       
      
      }


  },[listOfDataForStore])

  const getCheckIfIsRepeated=(permission_id,stage_name,transaction_name,section_id)=>{
    if(props.rows?.length>0){
      let finalArry=[];
  
                let checkExists=0;
                  props?.rows?.map((data)=>{
                      if(data?.permission_id== permission_id && data?.stage_name==stage_name&&transaction_name==data.transaction_name && data?.section_id==section_id){
                        checkExists=1;
                      }
                  })
                  if(checkExists==0){
                    return true;
                    
                  }else{
                    return false;
                  }
    }else{
      return true;
    }
  }

  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  const handleInputChange = (event, stage) => {
    const target = event.target;
    // console.log("ischecked",target.checked);
    var templistOfDataForStore = listOfDataForStore;
    let arr=[];
    let check_existing=false;
    if (target.checked) {
         
             listOfDataForStore?.map((data)=>{
                if(data?.stage_transaction_type_id==stage.id){
                    check_existing=true;
                    let arr2=[];
                
                    sections?.map((section)=>{
                      
                      arr2.push({
                        section_id:section?.id,
                        section_name:section?.name,
                        permission_list:getCurrentlyPermissionListData(data,section?.id)
                      })
                      
                    })
                    arr.push({
                      stage_transaction_type_id:stage?.id,
                      role_id:props?.object?.id,
                      sections_dataset:arr2,
                      check:true,
                    })

                  // expandOrCollapseIcon(data)
                }else{
                  arr.push(data);
                }
             })

             if(!check_existing){
              let arr2=[];
                
              sections?.map((section)=>{
                
                arr2.push({
                  section_id:section?.id,
                  section_name:section?.name,
                  permission_list:[1,2,3,4]
                })
                
              })
              arr.push({
                stage_transaction_type_id:stage?.id,
                role_id:props?.object?.id,
                sections_dataset:arr2,
                check:true,
              })

              // expandOrCollapseIcon(stage)
             }

            //  setListOfDataForStore(arr)

    }else {
      arr = listOfDataForStore.filter(function (item) {
        return item.stage_transaction_type_id != stage?.id
      })
    }
    setListOfDataForStore(arr)
    // props?.setRows([...props?.rows.filter(row=>!userBranchRolesSelected.filter(selected=>selected?.id===row?.id).length>0),...tempUserBranchRolesSelected])
  };
   const getCurrentlyPermissionListData=(data,section_id)=>{
         let result=[];
         data?.sections_dataset?.map((item)=>{
             if(item?.section_id==section_id){
              result = item?.permission_list  
             }
         })
         return result;
   }

  const handleInputChange_section = (event,stage,section) => {
    const target = event.target;
    // console.log("ischecked",target.checked);
    let arr=[];
    let check_existing = false;
    listOfDataForStore?.map((item)=>{
      
         if(item?.stage_transaction_type_id==stage.id){
          check_existing=true;
          var tempSectionsDataset = item?.sections_dataset;
          if (target.checked) {
                tempSectionsDataset=[
                  ...tempSectionsDataset,{
                      section_id:section?.id,
                      section_name:section?.name,
                      permission_list:[1,2,3,4]
                  }
                ]
        
          }else {
            tempSectionsDataset = item?.sections_dataset?.filter(function (itm) {
              return itm?.section_id !== section?.id
            })
            
          }
          arr.push({
            stage_transaction_type_id:item?.stage_transaction_type_id,
            role_id:props?.object?.id,
            sections_dataset:tempSectionsDataset,
            check:true,
            expand:true,
          })

         }else{
          arr.push(item)
         }
    })

    if(!check_existing){
      var tempSectionsDataset = [];
      if (target.checked) {
            tempSectionsDataset=[
              ...tempSectionsDataset,{
                  section_id:section?.id,
                  section_name:section?.name,
                  permission_list:[]
              }
            ]
    
      }
      
      arr.push({
        stage_transaction_type_id:stage?.id,
        role_id:props?.object?.id,
        sections_dataset:tempSectionsDataset,
        check:true,
        expand:true,
      })
    }

    setListOfDataForStore(arr)
   
    // props?.setRows([...props?.rows.filter(row=>!userBranchRolesSelected.filter(selected=>selected?.id===row?.id).length>0),...tempUserBranchRolesSelected])
  };

  const handleChange = (event,stage,section) => {
 
 


    let dataPer=[...event.target.value]
    console.log(dataPer)

 


     if(listOfDataForStore.length>0){
        let arr=[];

        listOfDataForStore.map((data)=>{
            if(data.stage_transaction_type_id == stage.id){
              // console.log(data.permission_list);
              
              if(data?.sections_dataset?.length>0){
                  let arr2=[];
                  data?.sections_dataset?.map((itm)=>{
                     if(itm?.section_id==section?.id){
                      console.log('true');
                        arr2.push({
                          section_id:itm?.section_id,
                          section_name:itm?.section_name,
                          permission_list:dataPer
                        })
                     }else{
                      console.log('false');

                      arr2.push(itm)
                     }
                  })
                  arr.push({
                    ...data,
                    sections_dataset:arr2,
               
                  })
              }else{
                arr.push(data)
              }

             


            }else{

              arr.push(data)

            }
        })
        console.log(arr);
        setListOfDataForStore(arr);
     }

  };

  const getCheckedSelect=(stage)=>{
    if(listOfDataForStore.length>0){

      let check=false;
      listOfDataForStore.map((data)=>{
        if(stage?.id==data.stage_transaction_type_id){
          check=true; 
        }
      })
      return check;

    }else{
       return false;
    }
  }

  const getCheckedSelect_section=(stage,section)=>{
    if(listOfDataForStore.length>0){

      let check=false;
      listOfDataForStore.map((data)=>{
        if(stage?.id==data.stage_transaction_type_id){
          if(data?.sections_dataset?.length>0)
          {
            data?.sections_dataset?.map((itm)=>{
              if(itm?.section_id==section?.id)
              {
                check=true;
              }
            })
            
          }
        }
      })
      return check;

    }else{
       return false;
    }
  }

  const getPermissionList=(stage,section)=>{
    if(listOfDataForStore.length>0){

      let check=[];
      listOfDataForStore.map((data)=>{
        if(stage?.id==data.stage_transaction_type_id){
          if(data?.sections_dataset?.length>0)
          {
            data?.sections_dataset?.map((itm)=>{
              if(itm?.section_id==section?.id)
              {
                check=itm?.permission_list;
              }
            })
            
          }
        }
      })
      return check;

    }else{
       return [];
    }
  }

  const getPermissionNameList=(id)=>{
    if(permissions.length>0){
      let name=''
      permissions.map((data)=>{
         if(data.id==id){
          name= data.name
         }
      })
      return name;
    }
  }
  
  // store data in database here...^-^
  const sentDataRequestToStore=async()=>{
    let data=null;
    setLoading(true)
    try{
      
      data = await axios({
        method: "post",
        url: ApiSettings.apiUrl + "/role_stage_transaction_type_permissions",
        data: {
          role_id:props?.object?.id,
          role_stage_transaction_type_permission:listOfDataForStore
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      console.log("update", data);
      if (data) {

        if (data.data.status == 200) {
          // setLoading(false);
          props?.setOpen(false)
          props?.loadDataList()

          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          // props.setReloadData()
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        // setLoading(false);
      }
      setLoading(false)
    }
    catch(err){
      setLoading(false)
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
    }
  }

  const getDataFromDataBase=async(transactionType)=>{
    let data=null;
    // setLoading(true)
    let arrOfID=[];
    transactionType?.map((trans)=>{
      trans?.stage_transaction_type?.map((itm)=>{
          arrOfID.push(itm.id);
      })
    })  

    try{
      
      data = await axios({
        method: "get",
        url: ApiSettings.apiUrl + "/role_stage_transaction_type_permissions/"+props?.object?.id,
        params:{
          stage_transaction_type:arrOfID
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      if (data) {

        if (data.data.status == 200) {
          // setLoading(false);
          setListOfDataForStore(data?.data?.data)

          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          // props.setReloadData()
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
      }
    }
    catch(err){
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
    }
  }

  // const setUpdateForData=async()=>{

  // }

  const expandOrCollapseIcon=(stage)=>{
    // const target = event.target;
    // console.log("ischecked",target.checked);
    let arr=[];
    let check_existing=false;
    // listOfDataForStore?.map((item)=>{
      
    //      if(item?.stage_transaction_type_id==stage.id){
    //       check_existing=true;
    //       // var tempSectionsDataset = item?.sections_dataset;
    //         if (item?.hasOwnProperty('expand') && item?.expand==true) {
    //           arr.push({
    //           ...item,
    //           expand:false,
    //           })
    //         }else{
    //           arr.push({
    //             ...item,
    //             expand:true,
    //           })
    //         }

    //      }else{
    //       arr.push(item)
    //      }
    // })
    // if(!check_existing){
       
    // }
    collapseShowing?.map((collapse)=>{
         if(collapse?.index==stage?.id){
            check_existing=true;
            if (collapse?.hasOwnProperty('expand') && collapse?.expand==true) {
              arr.push({
              ...collapse,
              expand:false,
              })
            }else{
              arr.push({
                ...collapse,
                expand:true,
              })
            }
         }
    })

    if(!check_existing){
      arr.push({
        index:stage?.id,
        expand:true,
      })
    }

    setCollapseShowing(arr)

  }

  const gethwoIsExpand=(stage)=>{
    let arr=[];
    let check=false;
    collapseShowing?.map((item)=>{
      
        if(item?.index==stage.id){
          // var tempSectionsDataset = item?.sections_dataset;
          if(!item?.hasOwnProperty('expand')){
             check=true;
          }
         if (item?.hasOwnProperty('expand') && item?.expand==true) {
             check=true;
          }
         else{
            check=false;
          }

         }
    })
    return check;

  }

  const getFullAllChecked=(stage)=>{
    let check=false;
    listOfDataForStore?.map((data)=>{
         if(data?.stage_transaction_type_id==stage.id){
             if(data?.sections_dataset?.length==sections?.length){
               check=true;
             }
         }
    })
     return check;
  }

  const getIndeterminateSelectBox=(stage)=>{
    let check=false;
    let counter_check=0;
    listOfDataForStore?.map((data)=>{
         if(data?.stage_transaction_type_id==stage.id){
             counter_check=1;
             if(data?.sections_dataset?.length==sections?.length){
               check=true;
             }
         }
    })
    if(counter_check===0){
      check=true;
    }

     return check;
  }


  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${props.inactive === false ? "activeSideMenu" : ""
        }`}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">الصلاحيات الوظيفية للمسمى الوضيفي {props?.object?.name}</span>
            </div>
          </div>
        </div>
      </div>

      {/* section1 here...  */}
      <div className="section1 container-lg py-4 px-2 pe-4">
        <div className="row">
          <div className="col-md-12   d-flex " style={{
            flexDirection: 'column',
            borderStyle: 'solid',
            borderColor: 'rgb(95, 123, 138)',
            borderWidth: '2px',
            borderRadius: '10px',
            paddingTop: '10px',
            paddingBottom: '10px'
          }}>

            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormGroup>
                <Autocomplete
                  // value={value}
                  onChange={(event, newValue) => {
                    // setValue(newValue);
                    // console.log("newValue", newValue);

                    if(newValue)
                    {
                      // getDataFromDataBase(newValue);
                      setTransactionDataList(newValue);
                     
                    }
                    else{
                      setTransactionDataList([]);
                    }
                  }}
                  // inputValue={inputValue}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, option) => (
                    
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.name} 
                    </Box>
                  )}
                  id="controllable-states-demo"
                  options={transactionTypes}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField {...params} label="اختر نوع الضريبة" />}
                />
              </FormGroup>
              <FormLabel component="legend">اختر من الصلاحيات الوظيفية التالية</FormLabel>
              <FormGroup>
                {TransactionDataList?.stage_transaction_type?.map((stage, index) => {
                  var isChecked = false;
                  // if (userBranchRolesSelected.length > 0 && userBranchRolesSelected.filter(selectedRole=>selectedRole?.id === stage?.pivot?.id)?.length>0) {
                  //   isChecked = true;
                  // }
                  return<div style={{width: '100%'}} key={stage?.id}>
                    <div style={{display:'flex',width:'100%'}}>
                     <FormControlLabel
                      sx={{width:"30%",flex:1}}
                      key={index + "_branch_stage"}
                      control={
                        <Checkbox
                            // checked={getCheckedSelect(stage)} 
                            checked={(getFullAllChecked(stage)&&getCheckedSelect(stage)?true:false)}
                            indeterminate={(!getIndeterminateSelectBox(stage)&&getCheckedSelect(stage)?true:false)}
                            onChange={(e) => handleInputChange(e, stage)}
                            name="gilad" 
                        />
                      }
                      label={stage?.stage?.name}
                     />
                     {
                      !gethwoIsExpand(stage)?
                          <ExpandMoreIcon color="gray" size="15px"  style={{cursor: "pointer"}} onClick={()=>{expandOrCollapseIcon(stage)}}/>
                          :
                          <ExpandLessIcon color="gray" size="15px"  style={{cursor: "pointer"}} onClick={()=>{expandOrCollapseIcon(stage)}}/>


                     }
                     </div>
                     {
                      gethwoIsExpand(stage)?
                      <FormControl sx={{ m: 1, width: "100%",borderLeft:'2px solid gray',flex: 1 }}>
                              {
                                sections&&sections.length>0?
                                 sections?.map((section)=>(
                                  <div style={{display: "flex",alignItems:'center'}} key={section?.id}>
                                        <div style={{width: "15%",border:'1px solid gray',height:'0px',background:'gray',position:'relative',left:'2px'}}>   
                                        </div>
                                        <FormControlLabel
                                          sx={{width:"50%"}}
                                          key={index + "_branch_stage"}
                                          control={
                                            <Checkbox checked={getCheckedSelect_section(stage,section)} onChange={(e) => handleInputChange_section(e,stage,section)} name="gilad" />
                                          }
                                          label={section?.name}
                                        />

                                        <FormControl sx={{ m: 1, width: "40%" }}>
                                            <InputLabel id="demo-multiple-chip-label">الصلاحيات</InputLabel>
                                            <Select
                                              disabled={!getCheckedSelect_section(stage,section)}
                                              labelId="demo-multiple-chip-label"
                                              id="demo-multiple-chip"
                                              multiple
                                              value={getPermissionList(stage,section)}
                                              onChange={(e)=>handleChange(e,stage,section)}
                                              input={<OutlinedInput id="select-multiple-chip" label="الصلاحيات" />}
                                              renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                  {selected.map((value) => (
                                                    <Chip key={value} label={getPermissionNameList(value) } />
                                                  ))}
                                                </Box>
                                              )}
                                              MenuProps={MenuProps}
                                            >
                                              {permissions.map((per) => (
                                                <MenuItem
                                                  key={per.name}
                                                  value={per.id}
                                                  style={getStyles(per.name, permissionsList, theme)}
                                                >
                                                  {
                                                  per.name
                                                  }
                                                </MenuItem>
                                              ))}
                                            </Select>
                                        </FormControl>

                                  </div>
                                 ))
                                :null
                              }
                      </FormControl>:null
                     }

                   
                  </div>
                })}




              </FormGroup>
               
              <FormHelperText>تستطيع اختيار اكثر من واحدة</FormHelperText>
              </FormControl>




            <Button
              variant="contained"
              className="mx-3 section1CarrerName section1Button mt-4 pt-1"
              onClick={() => {
                sentDataRequestToStore()
                
              }}
            >
              {!loading ? (
                "اضافة"
              ) : (
                <div className="spinner-border " role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </Button>

          </div>
        </div>
      </div>

      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
